// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"RegionListPage_buttonGroup__EcwUF"};